import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
const TextFieldCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "TextField", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.isDisabled || props.isReadOnly },
        React.createElement(PropsChecker, { componentName: "TextField", componentProps: props, defaultValueName: "defaultIsFocused", valueName: "isFocused", onChangeNames: ['onFocus', 'onBlur'] },
            React.createElement(AnalyticsTrigger, { trigger: [
                    {
                        callback: 'onFocus',
                        id: `Field - Focus - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'focus',
                    },
                    {
                        callback: 'onManualChange',
                        id: `Field - Filled - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'fill',
                    },
                    {
                        callback: 'onClear',
                        id: `Field - Clear - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'clear',
                    },
                ] },
                React.createElement(TextFieldCoreInner, Object.assign({}, props))))));
};
export default TextFieldCore;
export class TextFieldCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.focusedLabelTimeout = 0;
        this.input = null;
        this.clearButton = null;
        this.onChange = (event) => {
            const value = event.currentTarget.value;
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            /* istanbul ignore else */
            if (this.props.onManualChange && !this.state.isChanged) {
                this.props.onManualChange();
            }
            this.setState({
                isChanged: true,
            });
        };
        this.onFocus = () => {
            const done = () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            };
            if (this.props.isReadOnly || this.props.isStatic) {
                return done();
            }
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: true,
                });
            }
            this.setState({
                isFocusedLabel: true,
            });
            done();
        };
        this.onBlur = (event) => {
            const clickedOnCloseButton = event && this.clearButton && event.relatedTarget instanceof Element && this.clearButton.contains(event.relatedTarget);
            if (clickedOnCloseButton) {
                return;
            }
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: false,
                });
            }
            window.clearTimeout(this.focusedLabelTimeout);
            this.focusedLabelTimeout = window.setTimeout(() => this.setState({
                isFocusedLabel: false,
            }), 100);
            if (this.props.onBlur) {
                this.props.onBlur(event);
            }
        };
        this.clear = (event) => {
            event.preventDefault();
            const value = '';
            const prevValue = this.value;
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            if (this.props.onClear) {
                this.props.onClear(event);
            }
            /* istanbul ignore else */
            if (this.input && prevValue) {
                this.input.focus();
            }
        };
        this.setInputRef = (element) => {
            this.input = element;
            if (element && this.props.inputRef) {
                this.props.inputRef(element);
            }
        };
        this.state = {
            isFocused: props.defaultIsFocused || false,
            isFocusedLabel: false,
            value: props.defaultValue || '',
            isChanged: false,
        };
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusedLabelTimeout);
    }
    get value() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
        }
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    get isFocused() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
        }
        return this.props.onBlur && this.props.onFocus && typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
    }
    get isInvalid() {
        return this.props.isInvalid || !!this.props.helper && this.props.helper.type === 'error';
    }
    BEM() {
        const classArray = ['textfield'];
        if (this.value) {
            classArray.push('is-dirty');
        }
        if (this.props.isDisabled) {
            classArray.push('is-disabled');
        }
        if (this.props.isInvalid) {
            classArray.push('is-invalid');
        }
        if (!this.props.isStatic) {
            classArray.push('textfield--floating-label');
        }
        else {
            classArray.push('is-static');
        }
        if (this.isFocused) {
            classArray.push('is-focused');
        }
        if (this.props.size) {
            classArray.push('textfield--' + this.props.size);
        }
        if (this.props.align) {
            classArray.push('textfield--' + this.props.align);
        }
        if (this.props.hideLabel) {
            classArray.push('textfield--no-label-' + this.props.hideLabel);
        }
        if (this.props.icon || this.props.isClearable) {
            classArray.push('textfield--with-icon');
        }
        if (this.props.employee) {
            classArray.push('textfield--employee');
        }
        if (this.shouldRenderImage(this.props.image)) {
            classArray.push('textfield--image');
        }
        if (this.props.placeholderLabel && this.props.hideLabel !== 'no-break') {
            classArray.push('textfield--no-label-no-break');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    inputBEM() {
        const classArray = ['textfield__input'];
        if (this.props.inputClass) {
            classArray.push(this.props.inputClass);
        }
        return classArray.join(' ');
    }
    renderFormHelper(helper) {
        const { FormHelper } = this.props.components;
        return (React.createElement(FormHelper, Object.assign({}, helper, { className: "textfield__form-helper", id: helper.id || `${this.props.id}-helper` })));
    }
    getIcon() {
        const { Icon } = this.props.components;
        if (this.props.icon) {
            return React.createElement(Icon, { modifiers: this.props.icon, className: "textfield__icon" });
        }
        else {
            return null;
        }
    }
    getLabel() {
        if (this.state.isFocusedLabel) {
            return this.props.focusLabel ? this.props.focusLabel : this.props.label;
        }
        return this.props.label;
    }
    getContent() {
        if (this.props.contentRenderer) {
            return this.props.contentRenderer();
        }
        return null;
    }
    getClearButton() {
        const { ClearButton } = this.props.components;
        if (this.value && this.value.length > 0 || this.props.isClearable === 'always') {
            return (React.createElement(ClearButton, { className: "textfield__clear-btn", onClick: this.clear, label: this.props.clearButtonLabel, buttonRef: (el) => this.clearButton = el }));
        }
        return null;
    }
    shouldRenderImage(image) {
        return !!image && (this.value !== '');
    }
    getPlaceholder() {
        if (this.props.placeholderLabel) {
            return this.props.label;
        }
    }
    getAriaDescribedBy() {
        const arr = [];
        if (this.props['aria-describedby']) {
            arr.push(this.props['aria-describedby']);
        }
        if (this.props.helper) {
            arr.push((this.props.helper.id || `${this.props.id}-helper`));
        }
        return arr.join(' ');
    }
    render() {
        const InputElement = this.props.isTextarea ? 'textarea' : 'input';
        const { Image } = this.props.components;
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("div", Object.assign({ className: "textfield__inner" }, this.props.innerAttributes),
                this.getIcon(),
                this.shouldRenderImage(this.props.image) && React.createElement(Image, Object.assign({}, this.props.image, { className: "textfield__image" })),
                React.createElement("label", { className: "textfield__label", htmlFor: this.props.id, id: `${this.props.id}-label` },
                    React.createElement("span", { className: "textfield__label-text" }, this.getLabel())),
                React.createElement(InputElement, Object.assign({}, this.props.input, { id: this.props.id, readOnly: this.props.isReadOnly || this.props.isStatic, className: this.inputBEM(), onChange: this.onChange, onFocus: this.onFocus, onBlur: (event) => this.onBlur(event), onKeyDown: this.props.onKeyDown, value: this.value, disabled: this.props.isDisabled, placeholder: this.getPlaceholder(), ref: this.setInputRef, style: this.props.inputStyle, type: !this.props.isTextarea ? this.props.type : undefined, "aria-invalid": this.isInvalid, "aria-describedby": this.getAriaDescribedBy() })),
                this.getContent(),
                this.props.isClearable && this.getClearButton()),
            !!this.props.helper && this.renderFormHelper(this.props.helper)));
    }
}
